import { Type, Validator } from "./Type";
import {
  DatePickerComponent,
  DatePickerProps,
  DateTimeRenderer,
  PresentationalTimeComponentProps
} from "../index";

export type DateTimeFieldProps =
  | Validator
  | (DatePickerProps & PresentationalTimeComponentProps);

export const DateTimeField = (
  props?: DateTimeFieldProps,
  ...validators: Validator[]
) => {
  if (props instanceof Function) {
    validators.unshift(props);
  }

  return new Type({
    Component: DatePickerComponent,
    PresentationComponent: DateTimeRenderer,
    props: props,
    validators
  });
};
